import sha512 from "js-sha512";
import LoginApi from "../features/login/Login.api";
import { AuthTokenService } from "infra/api/httpClient";
import { StorageService } from "infra/storage";
import { DEFAULT_ROLE } from "constants/roles";

class LoginService {
    /**
     *
     * @param {JSON} credentials
     */
    async loginUser(credentials) {
        credentials.password = sha512(credentials.password);
        const response = await LoginApi.loginRequest(credentials);
        const token = response.token;
        const role = response.role || DEFAULT_ROLE;

        StorageService.setAuthToken(token);
        StorageService.setRole(role);
        AuthTokenService.set(token);
    }
}

const loginServiceInstance = new LoginService();
export default loginServiceInstance;
